import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=25f61728&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=ts"
export * from "./UserGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f61728",
  null
  
)

export default component.exports